module.exports = __webpack_public_path__ + "static/media/tour-popup-3-fig.fbfae08f.png";